import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { connect } from 'react-redux';
// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { Container } from 'reactstrap';
import { useIntl } from 'react-intl';
import { useMediaQuery } from 'react-responsive';
import { withTheme, Theme } from 'styled-components';
// @ts-ignore ts-migrate(7016) FIXME: Could not find a declaration file for module '@whi... Remove this comment to see the full error message
import { locales } from '@whitelabel/helpers/site';
// route not yet ready, (icon, design ready etc.) https://domainpartners.atlassian.net/browse/XCOM-1055
// import { ReactComponent as IconAssist } from '@whitelabel/media/icons/global/icon-16-chat.svg';
import { ReactComponent as IconCustomer } from '@whitelabel/media/icons/global/icon-16-customer.svg';
import { ReactComponent as IconCustomerLarge } from '@whitelabel/media/icons/global/icon-40-customer.svg';
import { ReactComponent as IconDollar } from '@whitelabel/media/icons/global/icon-16-dollar.svg';
import { ReactComponent as IconHelp } from '@whitelabel/media/icons/global/icon-16-information.svg';
import { ReactComponent as IconLang } from '@whitelabel/media/icons/global/icon-16-globe.svg';
import { ReactComponent as IconChevronDown } from '@whitelabel/media/icons/small/chevron-down.svg';
import { ReactComponent as IconChevronRight } from '@whitelabel/media/icons/small/chevron-right.svg';
import { ReactComponent as IconPower } from '@whitelabel/media/icons/small/power.svg';
import logo from '@whitelabel/media/logo.svg';
import { ICustomer, INavItem } from '../../../helpers/types';
import { authRoutes, localePrefix } from '../../../routes';

import { SITE_NAME, ENABLE_QUOTE_AND_BOOKING } from '../../../helpers/constants';
import {
  Brand,
  NavItem,
  PoweredByBrand,
  GlobalCustomerDropdown,
  MenuDropdown,
  SecondaryNav,
} from '../../../components/NavBar';
import LocaleModal from '../../../components/LocaleModal';
import {
  GlobalStyle,
  StyledGlobalNav,
  StyledNavBar,
  StyledNavBarToggler,
  StyledNav,
  StyledNavButton,
  StyledMenu,
  StyledNavSeperator,
  StyledPrimaryNavItems,
  StyledNavCustomer,
  StyledNavCustomerDetailsWrapper,
  StyledNavCustomerDetails,
  StyledNavCustomerIcon,
  StyledNavCustomerName,
  StyledNavCustomerEmail,
  StyledNavCustomerItems,
  StyledNavIcon,
  StyledBrandWrapper,
  StyledMenuGlobalNavItems,
  StyledNavButtonWrapper,
  // @ts-ignore ts-migrate(6142) FIXME: Module './styled' was resolved to '/Users/michae_m... Remove this comment to see the full error message
} from './styled';
import messages from './messages';

const customerNavItems = [
  { key: 'accountDropdown', messageKey: 'accountGlobalNavDropdownLink', path: '/account', name: 'account' },
  { key: 'claimsDropdown', messageKey: 'claimsGlobalNavDropdownLink', path: '/account/claims/fnol', name: 'claim' },
  { key: 'profileDropdown', messageKey: 'profileGlobalNavDropdownLink', path: '/profile', name: 'profile' },
];

const protectionNavItems = [
  {
    key: 'product',
    messageKey: 'productHeading',
    name: 'Product',
    path: '/',
    children: [
      {
        key: 'electronics',
        messageKey: 'electronicsLink',
        name: 'Electronics',
        path: '/electronics-warranty-insurance',
      },
      {
        key: 'Appliances',
        messageKey: 'appliancesLink',
        name: 'Appliances',
        path: '/appliances-warranty-insurance',
      },
      {
        key: 'Furniture',
        messageKey: 'furnitureLink',
        name: 'Furniture',
        path: '/furniture-warranty-insurance',
      },
      {
        key: 'Jewelry',
        messageKey: 'jewelryLink',
        name: 'Jewelry',
        path: '/jewelry-insurance',
      },
      {
        key: 'Sports Equipment',
        messageKey: 'sportsEquipmentLink',
        name: 'Sports Equipment',
        path: '/sports-equipment-warranty-insurance',
      },
      {
        key: 'Eyewear',
        messageKey: 'eyewearLink',
        name: 'Eyewear',
        path: '/eyewear-warranty-insurance',
      },
    ],
  },
  {
    key: 'business',
    messageKey: 'businessHeading',
    name: 'Business',
    path: '/',
    children: [
      {
        key: 'Shake Shield',
        messageKey: 'shakeShieldLink',
        name: 'Shake Shield',
        path: '/shake-shield',
      },
    ],
  },
  {
    key: 'travel',
    messageKey: 'travelHeading',
    name: 'Travel',
    path: '/',
    children: [
      {
        key: 'travel',
        messageKey: 'travelLink',
        name: 'Travel',
        path: '/travel-insurance',
      },
    ],
  },
  {
    key: 'other',
    messageKey: 'otherHeading',
    name: 'Other',
    path: '/',
    children: [
      {
        key: 'Ticket & Events',
        messageKey: 'ticketEventsLink',
        name: 'Ticket & Events',
        path: '/tickets-and-events-insurance',
      },
    ],
  },
];

const globalNavItems = [
  { key: 'claims', messageKey: 'claimsGlobalNavLink', path: '/claim', name: 'Claims', icon: IconDollar },
  { key: 'help', messageKey: 'helpGlobalNavLink', path: '/help', name: 'Help', icon: IconHelp },
  // route not yet ready, (icon, design ready etc.) https://domainpartners.atlassian.net/browse/XCOM-1055
  // { key: 'assist', messageKey: 'assistGlobalNavLink', path: '/assist', name: 'XCover Assist', icon: IconAssist },
];

const globalNavLogin = {
  key: 'login',
  messageKey: 'loginGlobalNavLink',
  name: 'Login',
  path: '/login',
  icon: IconCustomer,
};

const globalNavAccount = {
  key: 'account',
  messageKey: 'accountGlobalNavLink',
  path: '/account',
  name: 'Account',
  icon: IconCustomer,
};

const navProtection = {
  key: 'protection',
  messageKey: 'protectionNavLink',
  path: '/',
  name: 'Protection',
  icon: IconChevronDown,
};

const mobileCustomerNavLogout = {
  key: 'logout',
  messageKey: 'logoutLink',
  path: '/logout',
  name: 'Logout',
  icon: IconPower,
};

interface INavBarProps {
  customer?: ICustomer;
  cobrand?: {
    title: string;
    logo: string;
  };
  items?: INavItem[];
  size?: 'lg';
  background?: boolean;
  theme: Theme;
  hideGlobalNav?: boolean;
}

const NavBar = ({
  items = [],
  customer,
  cobrand,
  size,
  background,
  theme,
  hideGlobalNav,
}: INavBarProps): JSX.Element => {
  const intl = useIntl();
  const location = useLocation();
  const brand = cobrand ? { ...cobrand, size: 'lg' as const, link: false } : { title: SITE_NAME, logo, link: true };
  const [isOpen, setOpen] = useState(false);
  const toggleOpen = () => setOpen(!isOpen);
  const closeNav = () => {
    if (isOpen) {
      toggleOpen();
    }
  };
  const [isLocaleModalOpen, setIsLocaleModalOpen] = useState(false);
  const toggleLocaleModal = () => {
    closeNav();
    setIsLocaleModalOpen((prev) => !prev);
  };

  const [isSecondaryNavOpen, setIsSecondaryNavOpenOpen] = useState(false);
  const toggleSecondaryNav = () => setIsSecondaryNavOpenOpen((prev) => !prev);

  const toggleNav = () => {
    toggleOpen();
    if (isSecondaryNavOpen) {
      toggleSecondaryNav();
    }
  };

  const isTabletOrMobile = !useMediaQuery({ minWidth: theme.gridBreakpoints.lg }, undefined, closeNav);
  // fixed mobile menu height where menu moves from scrollable to fix CTA at bottom
  const isMobilePortraitHeight = useMediaQuery({ minHeight: 620 }, undefined);
  const isMobilePortraitHeightSecondary = useMediaQuery({ minHeight: 750 }, undefined);

  const authRoute = authRoutes.find((route) => {
    const localeRoute = route.path.replace(localePrefix, `/${intl.locale}`);
    return (
      localeRoute.substr(0, 10) === location.pathname.substr(0, 10) ||
      // coi and pds are not actually auth routes but should be treated as such when logged in
      location.pathname.includes(`/${intl.locale}/coi/`) ||
      location.pathname.includes(`/${intl.locale}/pds/`)
    );
  });

  const navItems: INavItem[] =
    customer && isTabletOrMobile
      ? [{ key: 'about', messageKey: 'aboutLink', name: 'About', path: '/about' }]
      : [...items];

  const renderCustomerItems = () => (
    <StyledNavCustomer>
      {customer?.firstName !== 'N/A' ? (
        <StyledNavCustomerDetailsWrapper>
          <StyledNavCustomerIcon as={IconCustomerLarge} />
          <StyledNavCustomerDetails>
            <StyledNavCustomerName>{`${customer?.firstName} ${customer?.lastName}`}</StyledNavCustomerName>
            <StyledNavCustomerEmail>{customer?.email}</StyledNavCustomerEmail>
          </StyledNavCustomerDetails>
        </StyledNavCustomerDetailsWrapper>
      ) : (
        <StyledNavCustomerDetailsWrapper>
          {/* @ts-ignore ts-migrate(17004) FIXME: Cannot use JSX unless the '--jsx' flag is provided... Remove this comment to see the full error message */}
          <StyledNavCustomerIcon $small as={IconCustomer} />
          <StyledNavCustomerEmail>{customer.email}</StyledNavCustomerEmail>
        </StyledNavCustomerDetailsWrapper>
      )}
      <StyledNavCustomerItems>
        {customerNavItems.map((item) => (
          <NavItem key={item.key} item={item} onClick={closeNav} />
        ))}
        <NavItem item={mobileCustomerNavLogout} onClick={closeNav} />
      </StyledNavCustomerItems>

      <StyledNavSeperator />
    </StyledNavCustomer>
  );

  const renderQuoteButton = (withWrapper = false, isOpen = false) => {
    if (ENABLE_QUOTE_AND_BOOKING) {
      const navBtn = (
        <StyledNavButton
          id="nav-get-quote-button"
          color="primary"
          data-analytics="navGetQuote"
          href={`/${intl.locale}/get-quote/product`}
        >
          {intl.formatMessage(messages.quoteButton)}
        </StyledNavButton>
      );

      return withWrapper ? <StyledNavButtonWrapper $fixed={isOpen}>{navBtn}</StyledNavButtonWrapper> : navBtn;
    }

    return null;
  };

  const renderAccountLink = () => {
    if (isTabletOrMobile) {
      return <NavItem item={globalNavAccount} />;
    }
    return <GlobalCustomerDropdown customerItems={customerNavItems} customer={customer} item={globalNavAccount} />;
  };

  const renderMerchantsAppLink = () => {
    const item = {
      key: 'merchants_app',
      name: 'Apps for Merchants',
      path: '/merchants',
      messageKey: 'appsForMerchants',
    };
    return (!authRoute || !customer || isTabletOrMobile) && <NavItem item={item} onClick={closeNav} />;
  };

  const renderProtectionLink = () => {
    if (isTabletOrMobile) {
      return (
        <li>
          <button onClick={toggleSecondaryNav} type="button">
            {intl.formatMessage(messages.protectionLink)}
            <StyledNavIcon as={IconChevronRight} />
          </button>
        </li>
      );
    }
    return (!authRoute || !customer) && <MenuDropdown items={protectionNavItems} item={navProtection} />;
  };

  const renderAffiliatesLink = () => {
    const navAPIAffiliates = {
      key: 'apiAffiliates',
      messageKey: 'apiAffiliatesLink',
      path: '/',
      name: 'API & Affiliates',
      icon: IconChevronDown,
    };

    const affiliatesNavItems = [
      { key: 'APIs', messageKey: 'apisLink', name: 'APIs', path: '/api' },
      { key: 'Affiliates', messageKey: 'affiliatesLink', name: 'Affiliates', path: '/affiliate-program' },
    ];

    if (isTabletOrMobile) {
      return affiliatesNavItems.map((item) => <NavItem key={item.key} item={item} onClick={closeNav} />);
    }
    return (!authRoute || !customer) && <MenuDropdown items={affiliatesNavItems} item={navAPIAffiliates} />;
  };

  const renderGlobalNavItems = () => {
    return (
      <>
        {globalNavItems.map((item) => (
          <NavItem key={item.key} item={item} onClick={closeNav} />
        ))}

        <li>
          <button onClick={toggleLocaleModal} type="button">
            <StyledNavIcon as={IconLang} />
            {/* @ts-ignore */}
            {locales[intl.locale].code}
          </button>
        </li>
      </>
    );
  };

  return (
    <div>
      {!hideGlobalNav && (
        <StyledGlobalNav color="black">
          <Container>
            {renderGlobalNavItems()}
            {!customer ? <NavItem item={globalNavLogin} onClick={closeNav} /> : renderAccountLink()}
          </Container>
        </StyledGlobalNav>
      )}

      <StyledNavBar
        id="NavBar"
        size={size}
        dark={isOpen}
        color={background ? 'white' : undefined}
        data-test-id="NavBar"
      >
        <Container>
          {cobrand ? (
            <StyledBrandWrapper $cobrand>
              <Brand {...brand} locale={intl.locale} customer={customer} />
              <PoweredByBrand />
            </StyledBrandWrapper>
          ) : (
            <StyledBrandWrapper>
              <Brand {...brand} locale={intl.locale} customer={customer} />
              {!!navItems.length && (
                <StyledNavBarToggler $active={isOpen} onClick={toggleNav} data-test-id="NavBar-toggler" />
              )}
            </StyledBrandWrapper>
          )}

          {!!navItems.length && (
            <>
              <StyledMenu $rtl={intl.bidi} $isOpen={isOpen} $isSecondaryNavOpen={isSecondaryNavOpen}>
                <div className="StyledMenu-container">
                  <GlobalStyle fixed={isOpen} />
                  <StyledNav navbar data-test-id="NavBar-nav">
                    <StyledPrimaryNavItems $rtl={intl.bidi} $customer={customer}>
                      {customer && renderCustomerItems()}
                      {renderProtectionLink()}
                      {renderAffiliatesLink()}
                      {renderMerchantsAppLink()}
                      {navItems.map((item) => (
                        <NavItem key={item.key} item={item} onClick={closeNav} />
                      ))}
                    </StyledPrimaryNavItems>

                    <StyledNavSeperator />

                    {/* mobile globalNav items */}
                    {isTabletOrMobile && (
                      <StyledMenuGlobalNavItems>
                        {renderGlobalNavItems()}
                        {!customer && <NavItem item={globalNavLogin} onClick={closeNav} />}
                      </StyledMenuGlobalNavItems>
                    )}
                    {renderQuoteButton(isTabletOrMobile && isMobilePortraitHeight, isOpen)}
                  </StyledNav>
                  {isTabletOrMobile && (
                    <StyledNav navbar $secondary={isOpen} data-test-id="NavBar-subNav">
                      <StyledPrimaryNavItems $rtl={intl.bidi} $secondary>
                        <SecondaryNav
                          items={protectionNavItems}
                          item={navProtection}
                          toggle={toggleSecondaryNav}
                          onClick={closeNav}
                        />
                      </StyledPrimaryNavItems>
                      {renderQuoteButton(isMobilePortraitHeightSecondary, isOpen)}
                    </StyledNav>
                  )}
                </div>
              </StyledMenu>
            </>
          )}
        </Container>
      </StyledNavBar>
      {isLocaleModalOpen && <LocaleModal isOpen={isLocaleModalOpen} toggle={toggleLocaleModal} />}
    </div>
  );
};

NavBar.defaultProps = {
  cobrand: null,
  items: [],
  size: null,
  background: false,
  customer: null,
  hideGlobalNav: false,
};

const mapStateToProps = (state: any) => ({
  customer: state.user.data ? state.customer.data : null,
});

// @ts-ignore ts-migrate(2345) FIXME: Argument of type 'FC<WithIntlProps<WrappedComponen... Remove this comment to see the full error message
export default connect(mapStateToProps, null)(withTheme(NavBar));
